module.exports = __webpack_public_path__ + "03_short_black.da9c74ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_short_black.png
// module id = cZ3T
// module chunks = 0